



















import {Component, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import CFlexGrid from '@/components/base/flex-grid/CFlexGrid.vue';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
@Component({
    components: {CEditDialog, CFlexGrid},
})
export default class PlanPlywoodOrderEditDialog extends Mixins(EditDialogMixin) {
    beforeSave() {
        this.data = (this.$refs.order as any).getSelectedList();
    }
}
